import React, {useEffect, useRef, useState } from 'react';
import { TabView,TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import { Messages } from 'primereact/messages';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import CmsService from '../../../service/CmsService';
import CatService from '../../../service/CatService';
import { Form } from '../../common/Form';
import { TestSearch } from '../../scr/test/TestSearch';
import { Toolbar } from 'primereact/toolbar';
import { CrtCond } from './CrtItemForm';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Steps } from 'primereact/steps';
import { ProcViewer } from '../../common/ProcViewer';
import ScrService from '../../../service/ScrService';
import {appTypes,contentTypes,testTypes} from '../../scr/const';
import { Panel } from 'primereact/panel';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'primereact/checkbox';

export function AutoSelectWizardLink()
{
    var {id} = useParams();

    const navigate = useNavigate();
    return <AutoSelectWizard id={id} navigate={navigate}/>
}
export function AutoSelectWizard({id,navigate})
{
    const {t}=useTranslation();
    const priorityOptions=[
        {label:t('AutoSelect.RANDOM'),value:'RANDOM'},
        {label:t('AutoSelect.LASTUSE'),value:'LASTUSE'},
        {label:t('AutoSelect.USAGE'),value:'USAGE'},
    ];
    const stepItems = [
        {label: t('General_settings')},
        {label: t('Exclude_Test_Items')},
        {label: t('Conditions')},
        {label: t('Result')}
    ];

    const messages=useRef(null);
    const [page,setPage]=useState(0);
    const [crt,setCrt]=useState({});
    const [onProgress,setOnProgress]=useState(false);
    const [autoSelect,setAutoSelect]=useState({crtId:id,priority:'RANDOM',approvedOnly:false,avgDiffEnabled:false,avgDiff:2.5,excRatio:100});
    const [test,setTest]=useState({testType:'EXAM'});
    const [proc,setProc]=useState();
    const [interval,setInterval]=useState(null);
    const [conds,setConds] = useState([]);
    const [result,setResult] = useState(null);
    const [typeCodes,setTypeCodes]=useState([]);
    const [excludeItems,setExcludeItems]=useState(false);

    const onPrev=(e)=>{
        if(page>0)
            setPage(page-1);
    }
    const startAutoSelect=()=>{
        var asel={...autoSelect,criteria:conds};
        CmsService.autoSelect(id,asel).then((ret)=>{
            setProc(ret);
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    }
    const onProcOK=(proc)=>{
        CmsService.getAutoSelectResult(proc.id).then((ret)=>{
            console.log("autoselect:"+JSON.stringify(ret));
            setResult(ret);
            setPage(3);
        });
    }
    const onNext=(e)=>{
        if(page == 0)
        {
            if(test.name == undefined || test.name.length == 0)
            {
                showError({message:"Name_not_valid"});
                return;
            }    
        }
        if(page == 2)
            startAutoSelect();
        else
            setPage(page+1);
    }
    const onFinish=(e)=>{
        var sects=[];
        result.results.forEach(r => {
            if(r.section>sects.length)
            {
                var sectNo=sects.length+1;
                var sect={name:'S'+sectNo,code:'S'+sectNo,ord:sectNo-1,qids:[]};
                sects.push(sect);
            }
            sects[r.section-1].qids=sects[r.section-1].qids.concat(r.qids);
        });
        var testDto={test:{...test,booklets:1,testStatus:'NOTREADY',
                    scoreMethod:{methodType:'BASIC',code:'SINGLE',name:'SINGLE'}},sects:sects};
        ScrService.insertTest(testDto).then(ret=>{
            console.log("create auto test:"+JSON.stringify(ret));
            navigate('/test/'+ret.id);
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    }

    const showError = (err) => {
		messages.current.show({ severity: 'error', summary: 'error', detail: err });
	}	
    const getFooter=()=>{
        const buttonCls = 'p-button-secondary mr-2';
        const prev = buttonCls + (page > 0? '':' hidden');
        const next = buttonCls + (page < 3? '':' hidden');
        const finish = buttonCls + (page == 3? '':' hidden');

        const footer = <span>
            <Button label={t("Previous")} icon="pi pi-chevron-left" className={prev} onClick={onPrev} disabled={onProgress}/>
            <Button label={t("Next")} icon="pi pi-chevron-right" loading={onProgress} className={next} onClick={onNext} disabled={onProgress}/>
            <Button label={t("Finish_and_create_test")} icon="pi pi-flag" className={finish} onClick={onFinish} disabled={onProgress}/>
            </span>;   
        return footer;
    }
    const getTitle=()=>{
        const title = <div className="flex justify-content-between"><div><h4>{t('Auto_Create_Test')}</h4></div><div><h4>{crt.name}</h4></div></div>
        return title;
    } 
    const addCond=(e)=>{
        var c=[...conds,{}];
        setConds(c);
        onChange({...autoSelect,criteria:c});
    }
    const condBar=()=>{
        return(
            <><Button label={t("Add_Condition")} onClick={addCond}></Button></>
        )
    }
    const onChange=({autoSel,crt})=>{}

    const onCondChange=(cond,index,newVal)=>{
        var cs=[...conds];
        cs[index]=newVal;
        setConds(cs);
        onChange({...autoSelect,criteria:cs});
    }
    const onDeleteCond=(cond,index)=>{
        var cs=[...conds];
        cs.splice(index,1);
        setConds(cs);
        onChange({...autoSelect,criteria:cs});
    }
    const onValChange=(vals)=>{
        var it={...autoSelect,...vals};
        setAutoSelect(it);
        onChange({...it,criteria:conds});
    }
    const onValChangeTest=(vals)=>{
        var it={...test,...vals};
        setTest(it);
    }
    const getSeverity = (crt) => {
        if(crt.required>crt.selected)
            return 'danger';
        return 'success';
    };    
    const statusBodyTemplate = (crt) => {
        if(crt.required>crt.selected)
            return <i class="pi pi-cross"></i>
        return <i class="pi pi-check"></i>
    };    
    const onTestSelect=(tests)=>{
        var excTests=tests.map(t=>t.id);
        var asel = {...autoSelect,excTests:excTests};
        setAutoSelect(asel);
    }
    const retrieveTypeCodes=()=>{
        CatService.getUdfByEntity('ALL').then((udfs)=>{
            udfs.forEach(udf => {
                if(udf.name=='examTypeCode')
                {
                    setTypeCodes(udf.options);
                    //{examTypeCode:udf,typeCodes:
                }
            });
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    };
    const retrieveCrt=()=>{
        CmsService.getCrt(id).then(ret=>{
            setCrt(ret.crt);
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    }
    useEffect(()=>{
        retrieveCrt();
        retrieveTypeCodes();
    },[]);
    const onExcludeOn=(e)=>{
        setExcludeItems(e.checked);
    }
    const testTypeOptions=()=>{
        return testTypes.map((item)=>{return {label:t('TestType.'+item.value),value:item.value}});
    }
    return(
        <div className="col-12 xl:col-8">
        <Card footer={getFooter()} title={getTitle()}>
        <Messages ref={messages}></Messages>
        <ProcViewer service={CmsService} procId={proc!=undefined?proc.id:-1} onOK={onProcOK}></ProcViewer>        
		<TabView activeIndex={page} renderActiveOnly onTabChange={(e) => setPage(e.index)}>
            <TabPanel header={t("Criteria")} headerTemplate={<></>}>
                <div className="pt-2">
                <h5>{t('General_Settings')}</h5>
                <Form id="tst" formData={test} columns="2" onChange={onValChangeTest}
                    fields={[
                        {id:"name",ftype:"text",field:"name",label:t("Test_name")},
                        {id:"examType",ftype:"dropdown",field:"examType",label:t("Exam_Type"), options:typeCodes},
                        {id:"testNo",ftype:"text",field:"testNo",label:t("Test_Code")},
                        {id:"testType",ftype:"dropdown",field:"testType",label:t("Assessment_Type"),options:testTypeOptions()}
                    ]}>
                </Form>	

                <Form id="crt" formData={autoSelect} columns="1" onChange={onValChange}
                    fields={[
                        {id:"approvedOnly",ftype:"checkbox",field:"approvedOnly",label:t("Select_approved_questions_only")},
                        {id:"avgDiffEnabled",ftype:"checkbox",field:"avgDiffEnabled",label:t("Try_to_achieve_average_difficulty")},
                    ]}>
                </Form>	
                <Form id="crt2" formData={autoSelect} columns="2" onChange={onValChange}
                    fields={[
                        {id:"avgDiff",ftype:"number",step:.1,field:"avgDiff",label:t("Average_difficulty_value"),disabled:!autoSelect.avgDiffEnabled},
                        {id:"priority",ftype:"dropdown",field:"priority",label:t("Selection_Priority"),options:priorityOptions}
                    ]}>
                </Form>	
                </div>
            </TabPanel>
            <TabPanel header={t("Exclude_test_items")} headerTemplate={<></>}>
                <div className="pt-4">
                    <div className="flex align-items-center mb-4">
                        <Checkbox inputId="excludeOn" name="excludeOn" value="false" 
                            onChange={onExcludeOn} checked={excludeItems} />
                        <label htmlFor="excludeOn" className="ml-2">{t('Exclude_Items_Used_in_Previous_Tests')}</label>
                    </div>
                    <div className={excludeItems?'':'hidden'}>
                        <Form id="crt2" formData={autoSelect} columns="4" onChange={onValChange}
                            fields={[
                                {id:"excRatio",ftype:"number",step:10,field:"excRatio",label:t("Exclusion_Ratio_(%)")},
                            ]}>
                        </Form>	
                        <Panel header={t("Select_tests_for_exclusion")}>
                            <TestSearch sectSelect={false} selectionMode="multiple" onTestSelect={onTestSelect}></TestSearch>
                        </Panel>
                    </div>
                </div>                
            </TabPanel>
            <TabPanel header={t("Conditions")} headerTemplate={<></>}>
                <div className="pt-4">
                <h5>{t('Extra_Conditions')}</h5>
                <Toolbar start={condBar} className="mb-2"></Toolbar>
                { conds.map((c,index)=>{return <CrtCond cond={c} onChange={(val)=>onCondChange(c,index,val)} onDelete={c=>onDeleteCond(c,index)}/>}) }
                </div>
            </TabPanel>
            <TabPanel header={t("Result")} headerTemplate={<></>}>
                <div className="pt-4">
                <h5>Result of Auto Selection</h5>
                    {result?
                    <DataTable value={result.results}>
                        <Column field="crtItemId" header={t("Id")}></Column>
                        <Column field="summary" header={t("Summary")}></Column>
                        <Column field="required" header={t("Required_Questions")}></Column>
                        <Column field="selected" header={t("Selected_Questions")}></Column>
                        <Column body={statusBodyTemplate} header={t("Status")}></Column>

                    </DataTable>
                    :''}
                </div>
            </TabPanel>
        </TabView>
        </Card>
        </div>
		);
}
